import React, { Component } from 'react'
import styled from 'styled-components'
import posed from 'react-pose'

const Wrapper = posed.div({
  closed: {
    transform: 'rotate(0deg)'
  },
  
  open: {
    transform: 'rotate(45deg)'
  }
})

const Path = styled.path`
  stroke: ${props => props.theme.colors.grey.dark};
`

export default class IconPlus extends Component {
  render() {
    const { open } = this.props
    
    return(
      <Wrapper pose={open ? 'open' : 'closed'}>
        <svg
          width="16"
          height="16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <Path
            d="M1 8h14M8 1v14"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="square"
          />
        </svg>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Accordions/IconPlus.js